(() => {
  const policyUrl = document.currentScript?.dataset.policyUrl;
  if (!policyUrl) return;

  // Shopify Forms renders its popup inside an open shadow root. Click events
  // cross that boundary, and composedPath exposes the link that was clicked.
  document.addEventListener('click', (event) => {
    const path = event.composedPath();
    const fromShopifyForm = path.some((node) => node instanceof Element && node.tagName === 'SHOPIFY-FORMS-EMBED');
    if (!fromShopifyForm) return;

    const link = path.find((node) => node instanceof HTMLAnchorElement && /privacy\s+policy/i.test(node.textContent));
    if (!link) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(policyUrl);
  }, true);

  const attachCountryScrollbarFix = (host) => {
    const root = host.shadowRoot;
    if (!root || root.countryScrollbarFixAttached) return;
    root.countryScrollbarFixAttached = true;

    // The popup's styles live in its shadow root, outside the theme stylesheet.
    const privacyCursorStyle = document.createElement('style');
    privacyCursorStyle.textContent = 'a[title="Privacy Policy"], a[title="Privacy Policy"] * { cursor: pointer !important; }';
    root.appendChild(privacyCursorStyle);

    let scrollingList = null;
    let clearInteraction;

    root.addEventListener('pointerdown', (event) => {
      const list = event.target.closest?.('[role="listbox"][id="country-selector-dropdown"]');
      if (!list) return;

      const bounds = list.getBoundingClientRect();
      const scrollbarWidth = Math.max(12, list.offsetWidth - list.clientWidth);
      if (event.clientX < bounds.right - scrollbarWidth - 4) return;

      scrollingList = list;
      clearTimeout(clearInteraction);
      clearInteraction = setTimeout(() => { scrollingList = null; }, 500);
    }, true);

    root.addEventListener('focusout', (event) => {
      if (!scrollingList || !scrollingList.contains(event.target)) return;
      // The app closes the list on blur, even when focus was lost to its scrollbar.
      event.stopImmediatePropagation();
    }, true);

    root.addEventListener('pointerup', () => {
      clearTimeout(clearInteraction);
      clearInteraction = setTimeout(() => { scrollingList = null; }, 150);
    }, true);
  };

  const watchForms = () => {
    document.querySelectorAll('shopify-forms-embed').forEach(attachCountryScrollbarFix);
  };

  watchForms();
  new MutationObserver(watchForms).observe(document.documentElement, { childList: true, subtree: true });
})();
